/**
 * @param  {EditorState} editorState
 * @return {Boolean}
 */
export default function isSelectedBlockEmpty(editorState) {
  const selectionState = editorState.getSelection();
  const currentContent = editorState.getCurrentContent();
  const currentContentBlock = currentContent.getBlockForKey(selectionState.getFocusKey());

  return currentContentBlock.getText().length === 0;
}
